(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular
    .module('vcutils.sprhelp', []);

  angular.module('vcutils.sprhelp').config(function ($uibTooltipProvider) {
    $uibTooltipProvider.options({
      mouseover: 'outsideClick'
    });
  });

}());
